import { render, staticRenderFns } from "./CubeNavItem.vue?vue&type=template&id=18fa077e&scoped=true&"
import script from "./CubeNavItem.vue?vue&type=script&lang=js&"
export * from "./CubeNavItem.vue?vue&type=script&lang=js&"
import style0 from "./CubeNavItem.vue?vue&type=style&index=0&id=18fa077e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fa077e",
  null
  
)

export default component.exports